import { useEffect, useState } from 'react';

export const useTableOverflow = () => {
  useEffect(() => {
    const scrollContainer = document.querySelector('.main-table-scroll-container');
    
    if (scrollContainer) {
      const checkOverflow = () => {
        if (scrollContainer.scrollWidth > scrollContainer.clientWidth) {
          scrollContainer.classList.add('has-overflow');
        } else {
          scrollContainer.classList.remove('has-overflow');
        }
      };
      
      checkOverflow();
      window.addEventListener('resize', checkOverflow);
      
      return () => {
        window.removeEventListener('resize', checkOverflow);
      };
    }
  }, []);
}; 

export const useMenuState = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.comparison-menu') && !event.target.closest('.comparison-menu-button')) {
        setMenuOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return { menuOpen, setMenuOpen, toggleMenu };
};

export const useMobileState = (breakpoint = 767) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};